<script lang="ts" setup>
import { ButtonStyle } from '~/static/enums/components/button'
import AButton from '~/components/atoms/buttons/Button.vue'
import RModal from '~/components/organs/Modal.vue'

const toTarifs = () => {
  window.parent.postMessage({ action: 'limit' }, '*')
  closeModal()
}

const refModal: Ref = ref(null)
const closeModal = () => {
  if (refModal.value !== null) {
    refModal.value.closeModal()
  }
}
const openModal = () => {
  if (refModal.value !== null) {
    refModal.value.openModal()
  }
}
defineExpose({
  closeModal,
  openModal,
})

</script>

<template>
  <RModal
    name-modal="downloadNotAvailableModal"
    size="lg"
    role="dialog"
    ref="refModal"
  >
    <template #header>
      <h5
        class="modal-title fs-5"
        id="downloadNotAvailableModalLabel"
      >
        Не осталось скачиваний
      </h5>
    </template>
    
    <template #body>
      <div class="body">
        <span class="d-block mb-lg-3">
          Чтобы скачивать дальше, подключите платный тариф
        </span>
      </div>
    </template>
    <template #footer>
      <AButton
        :button-style="ButtonStyle.Secondary"
        @click="closeModal"
      >
        Отмена
      </AButton>
      <AButton
        :button-style="ButtonStyle.Primary"
        @click="toTarifs"
      >
        К подключению
      </AButton>
    </template>
  </RModal>
</template>
  
<style lang="scss" scoped></style>
